import * as Sentry from "@sentry/react";

const ENABLE_LOCALHOST_LOGGING = true;

export function initSentry() {
    const traceTargets: (string | RegExp)[] = [
        "https://portal-retaguarda.avenida.com.br",
        /^https:\/\/portal-retaguarda\.avenida\.com\.br/,
        "*",
    ];

    if (ENABLE_LOCALHOST_LOGGING) {
        traceTargets.push("localhost");
    }

    Sentry.init({
        dsn: import.meta.env.VITE_REACT_SENTRY_DSN || "",
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: traceTargets,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}
